import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from "../../../tables";

export const logisticsPermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.DELIVERY_ROADMAPS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.DRIVERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.ROADMAPS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.VEHICLES, actions: [Action.SAVE, Action.REMOVE] }
])
